var crypto = require('crypto')

exports.createSign = crypto.createSign
exports.Sign = crypto.Sign

exports.createVerify = crypto.createVerify
exports.Verify = crypto.Verify



//////////////////
// WEBPACK FOOTER
// ./~/browserify-sign/index.js
// module id = 864
// module chunks = 0 1 2 3